import { error, finish } from '../../../modules/markets/actions/add-selection';
import api from '../../../api';

export async function request(dispatch, { eventId, marketId, templateId, params }) {
    const data = params === null || params === undefined ? { name: 'Custom' } : params;
    const body = {
        event_id: eventId,
        market_id: marketId,
        selection_id: templateId,
        requestBody: { data }
    };

    try {
        await $appState.sdkStaff.createSelection(body);

        return dispatch(finish(marketId));
    } catch (e) {
        return dispatch(error(marketId, e));
    }
}
